var isActivationSubmitForm = require('./is-activation-submit-form.js');

module.exports = function (element, form) {
  return (
    element && // exist
    element.form === form && // have the right form owner
    isActivationSubmitForm(element) && // right element and type
    !element.disabled // is not disabled
  );
};
